<ng-container *ngFor="let list of listViewData; trackBy: trackByListSpec">
    <ng-container *ngIf="list.isVisible">
        <lm-list
            #LMListComponent
            [listUrlInfo]="list.listUrlInfo"
            [listSpec]="list.listSpec"
            [fromDataView]="fromDataView"
            [listText]="list.panelText"
            [specialActions]="list.specialActions"
            (listDisplayed)="onListDisplayed($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (contentModified)="onContentModified($event)"
            (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
            (listTransactionEvent)="onPanelTransactionEvent($event)"
        ></lm-list>
    </ng-container>
</ng-container>

